import {reqWithToken} from './requestHelper';

export async function getForms(){
    return (await reqWithToken('api/gxbooking/manage')).data;
}


export async function deleteForm(id){
    return (await reqWithToken('api/gxbooking/manage',{
        params: {id},
        method: 'delete'
    })).data;
}

export async function cancelEvent(id){
    return (await reqWithToken('api/gxbooking/manage/cancel',{
        params: {id},
        method: 'put'
    })).data;
}

